import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, withStyles } from '@material-ui/core'
import { Label } from '../../default'
import { CardNotification } from '../../cards'
import TableNotification from './TableNotification'

const PanelNotification = ({ classes }) => {

  const { t } = useTranslation()

  return (
    <Grid container spacing={3} className={classes.root}>
      <Grid item xs={12}>
        <Label v='h5' bold>{t('panels.notifications.title')}</Label>
      </Grid>
      <Grid item xs={12}>
        <CardNotification />
      </Grid>
      <Grid item xs={12}>
        <TableNotification />
      </Grid>
    </Grid>
  )
}

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

export default withStyles(styles)(PanelNotification)